<template lang="pug">
  .ticket(v-if="ticket && ticket.session")
    .ticket__code(v-if="ticket.qr")
      qrcode-vue(:value="ticket.qr" :size="90" level="H")
    .ticket__desc
      .desc_title
        .tit(v-if="ticket.ticket_code") № билета {{ticket.ticket_code}}
        .tit(v-if="!ticket.ticket_code") Билет
        a(v-if="check(ticket)",
          @click="returnTicket()", href="#")
          icon(name="close")
        a(v-if="!ticket.qr",
          @click="cancelTicket()", href="#")
          icon(name="close")
      .desc_row
        .col(v-if="ticket.hall_name.length")
          .key Зал:
          .value {{ticket.hall_name}}
        .col
          .key Ряд:
          .value {{ticket.row!=0?ticket.row:'-'}}
        .col
          .key Место:
          .value {{ticket.place!=0?ticket.place:'-'}}
      .desc_row(v-if="!external")
        .col
          .key Стоимость:
          .value {{getPrice(ticket.price)}}
        .col
          .key Коммиссия:
          .value {{getPrice(ticket.commission)}}
        .col
          .key Скидка:
          .value {{getPrice(ticket.discount)}}
        .col
          .key Итого:
          .value {{getPrice(ticket.total_amount)}}
    popup-return(v-if="showReturn", :orderId="orderId", :ticket="ticket",
      @close="showReturn = false", @onReturn="update()")
    popup-cancel(v-if="showCancel", :orderId="orderId", :ticketId="ticket.id",
      @close="showCancel = false", @onCancel="update()")
</template>

<script>
import QrcodeVue from 'qrcode.vue';

import popupReturn from '@/components/popups/return.vue';
import popupCancel from '@/components/popups/cancel.vue';
import Icon from '@/components/Icons.vue';

export default {
  props: ['ticket', 'orderId', 'external'],
  data() {
    return {
      showReturn: false,
      showCancel: false,
    };
  },
  components: {
    QrcodeVue,
    Icon,
    popupReturn,
    popupCancel,
  },
  methods: {
    check(ticket) {
      if (ticket.qr && !(ticket.scanned_at || ticket.printed_at)
        && this.getDisabled(ticket.session.timeSpending)
        && ticket.total_amount > 0) {
        return true;
      }
      return false;
    },
    update() {
      this.$emit('update');
      this.showReturn = false;
      this.showCancel = false;
    },
    returnTicket() {
      this.showReturn = true;
    },
    cancelTicket() {
      this.showCancel = true;
    },
    getDisabled(time) {
      return time > Math.floor(Date.now() / 1000);
    },
    getPrice(value) {
      if (value || value === 0) {
        const val = (value / 100).toFixed(2).replace('.', ',');
        return `${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} р.`;
      }
      return '';
    },
  },
};
</script>

<style lang="scss">
.ticket{
  display: flex;
  border-top: 1px dotted #ddd;
  padding: 1.5rem 0;
  &__desc{
    padding: 0 1rem;
    width: 100%;
    .desc_title{
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      font-weight: 500;
    }
    .desc_row{
      padding: 1.5rem 0;
      display: flex;
      font-size: 14px;
      justify-content: flex-start;
      & + .desc_row {
        padding-top: 0;
      }
      .col{
        padding-right: 1.5rem;
        .key{
          font-size: 12px;
          color: #aaa;
          margin-bottom: .5rem;
        }
      }
    }
  }
}
</style>
